import { render } from "./AddressExchangeDisplayModal.vue?vue&type=template&id=8e6f6cc6&scoped=true"
import script from "./AddressExchangeDisplayModal.vue?vue&type=script&lang=js"
export * from "./AddressExchangeDisplayModal.vue?vue&type=script&lang=js"

import "./AddressExchangeDisplayModal.vue?vue&type=style&index=0&id=8e6f6cc6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e6f6cc6"]])

export default __exports__